import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import {
  BadgeStatus,
  VerifyBadgeDocument,
} from '@sandtech-hub-monorepo/ehub-client';

import { CredentialVerifyView } from '../../components/credentials/CredentialVerifyView';

/** Public: /badges/verify/:code, where the gateway's badge link lands. */
export const BadgeVerify = () => {
  const { verificationCode } = useParams<{ verificationCode: string }>();
  const { data, loading } = useQuery(VerifyBadgeDocument, {
    variables: { verificationCode: verificationCode ?? '' },
    skip: !verificationCode,
  });
  const badge = data?.verifyBadge;
  const imageUrl =
    badge?.status === BadgeStatus.Revoked
      ? badge.revokedImageUrl ?? badge.badgeImageUrl
      : badge?.badgeImageUrl;

  return (
    <CredentialVerifyView
      kind="badge"
      loading={loading}
      credential={
        badge && {
          subjectLabel: 'Course',
          title: badge.courseName ?? badge.badgeName,
          issuer: badge.issuer,
          recipientName: badge.recipientName,
          issuedAt: badge.issuedAt,
          expiresAt: badge.expiresAt,
          verificationCode: badge.verificationCode,
          status: badge.status,
          isValid: badge.isValid,
          description: badge.badgeDescription,
          imageUrl,
          downloadUrl: imageUrl,
        }
      }
    />
  );
};
